<template>
  <div v-if="group" class="group-details">
    <div>
      <div
        v-if="group.cover"
        class="cover"
        v-lazy:background-image="group.cover.url"
      ></div>
    </div>
    <div class="container section">
      <div class="columns">
        <div class="column">
          <group-header :group="group" />
        </div>
        <div class="column is-one-third"></div>
      </div>

      <div class="columns tw-mt-12">
        <div class="column">
          <div class="about tw-mb-6" v-html="group.about"></div>
          <div class="columns">
            <div class="column">
              <div class="section-block no-border">
                <span class="title">OUR VISION</span>
              </div>
              <div v-html="group.vision"></div>
            </div>
            <div class="column">
              <div class="section-block no-border">
                <span class="title">VALUES</span>
              </div>
              <div class="content">
                <ul>
                  <li v-for="(values, key) in group.values" :key="key">
                    <span v-if="values">{{ values.values }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Scrapbook -->
          <div>
            <div class="section-block">
              <span class="title">OUR SCRAPBOOK</span>
            </div>
            <div
              v-if="posts.data.length || group.is_member"
              class="group-scrapbooks"
            >
              <div class="columns is-multiline">
                <div v-if="group.is_member" class="column is-one-third is-flex">
                  <div class="scrapbook-new">
                    <a
                      @click="$refs.createPost.open()"
                      href="javascript:;"
                      class="share is-family-secondary"
                    >
                      Share a Post
                    </a>
                  </div>
                </div>
                <div
                  v-for="post in posts.data"
                  :key="post.id"
                  class="column is-one-third"
                >
                  <scrapbook-card @report="onPostReported" :post="post" />
                </div>
              </div>

              <b-pagination
                class="tw-mt-8"
                v-if="posts.meta.last_page > 1"
                @change="onPageChanged"
                :total="posts.meta.total"
                :current.sync="posts.meta.current_page"
                :per-page="posts.meta.per_page"
                order="is-centered"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
              >
              </b-pagination>
            </div>
            <div v-else class="tw-text-gray-300 tw-italic">No posts yet.</div>
          </div>

          <!-- Comments & Discussion -->
          <div>
            <div class="section-block">
              <span class="title">COMMENTS &amp; DISCUSSION</span>
            </div>
            <div>
              <comment :refresh="refresh" v-if="group" :model="group" />
            </div>
          </div>
        </div>
        <div class="column is-one-third">
          <calendar :refresh="refresh" :pageGroup="pageViewGroup" />
          <!-- noticeboard -->
          <noticeboard v-if="group.is_member" />
          <!-- this week group session -->
          <session />
        </div>
      </div>
    </div>

    <create-post-modal
      @posted="getPosts"
      post-to="LTG"
      v-if="group.is_member"
      ref="createPost"
    />

    <report-modal ref="reportPost" :item="reportedPost" />
  </div>
</template>

<script>
import ScrapbookCard from '@/components/ScrapbookCard'
import Noticeboard from './components/Noticeboard'
import Session from './components/Session'
import GroupHeader from '@/components/GroupHeader'
import Calendar from '@/components/Calendar'
import { mapActions, mapState, mapGetters } from 'vuex'
import CreatePostModal from '@/components/modals/CreatePost'
import ReportModal from '@/components/modals/Report'
import Comment from '@/components/comment'

export default {
  components: {
    GroupHeader,
    ScrapbookCard,
    Noticeboard,
    Session,
    CreatePostModal,
    ReportModal,
    Comment,
    Calendar
  },
  metaInfo() {
    if (this.group) {
      return {
        title: this.group.name
      }
    }
  },
  data() {
    return {
      reportedPost: null,
      posts: {
        data: [],
        meta: {
          current_page: 1
        }
      },
      refresh: false,
      pageViewGroup: ''
    }
  },
  async mounted() {
    await this.fetchGroupDetails()
  },
  computed: {
    ...mapState({
      currentGroup: state => state.currentGroup,
      group: state => state.group.currentGroup
    }),
    ...mapGetters('auth', ['currentUserGroup'])
  },
  methods: {
    ...mapActions({
      viewGroup: 'group/viewGroup',
      getCurrentGroup: 'group/getCurrentGroup',
      getCalendarEvents: 'group/getCalendarEvents'
    }),

    async fetchGroupDetails() {
      const slug = this.$route.params.slug
      const isViewing =
        this.$route.name === 'groups.show' &&
        (this.currentGroup && this.currentGroup.slug) !== slug
      try {
        if (isViewing) {
          await this.viewGroup(slug)
          this.pageViewGroup = slug
        } else {
          await this.getCurrentGroup()
        }
        await this.refreshContent()
        this.getPosts()
      } catch (e) {
        if (isViewing) {
          this.$router.replace({ name: 'home' })
        } else {
          this.$router.replace({ name: 'groups.edit' })
        }
      }
    },

    onPageChanged(page) {
      this.posts.meta.current_page = page
      this.getPosts()
    },

    onPostReported(post) {
      this.reportedPost = post
      this.$refs.reportPost.open()
    },

    getPosts() {
      this.group
        .posts()
        .include('user', 'image')
        .page(this.posts.meta.current_page)
        .limit(10)
        .get()
        .then(response => {
          this.posts = response
        })
    },
    refreshContent() {
      this.refresh = true

      setTimeout(() => {
        this.refresh = false
      }, 2000)
    }
  },
  watch: {
    $route(n, o) {
      this.fetchGroupDetails()
    }
  }
}
</script>
